import { urlToPromise } from '../getUrlFromPromise';

describe('getUrlFromPromise', () => {
  it('should return a promise', () => {
    expect(
      urlToPromise('https://s3-us-west-2.amazonaws.com/abcdef.jpg'),
    ).toBeInstanceOf(Promise);
  });
});
